import { IHexGridData, directionCubeOffsets } from 'js/bubbleCore/types';
import { Hex } from 'js/bubbleCore/Hex';
import { isInGrid } from 'js/bubbleCore/utils/isInGrid';
import { getGridValue } from 'js/bubbleCore/utils/getGridValue';

export function getNeighboursHexes<T>(
  grid: IHexGridData<T>, origin: Hex,
): Hex[] {
  const result: Hex[] = [];
  const originRounded = origin.clone().round();

  Object.values(directionCubeOffsets).forEach(([x, y, z]) => {
    const neighbourHex = new Hex(grid.type).setCube(x, y, z).add(originRounded);
    if (isInGrid(grid, neighbourHex.offsetPosition.x, neighbourHex.offsetPosition.y)) {
      result.push(neighbourHex);
    }
  });

  return result;
}